import React from 'react';
import './PortfolioRow.css';

interface PortfolioRowProps {
    title: string;
    description: string;
    link: string;
    image?: string;
    imageFit?: 'cover' | 'contain';
}

const PortfolioRow: React.FC<PortfolioRowProps> = ({
    title,
    description,
    link,
    image,
    imageFit = 'cover'
}) => {
    return (
        <div className="portfolio-row">
            {/* Column 1: Icon */}
            <div className="row-col row-icon">
                <a href={link} target="_blank" rel="noopener noreferrer" className="icon-link">
                    {image ? (
                        <div className="row-image-container">
                            <div
                                className={`row-image ${imageFit}`}
                                style={{ backgroundImage: `url(${image})` }}
                            />
                        </div>
                    ) : (
                        <div className="row-image-container">
                            <div className="row-image-placeholder">
                                {title.charAt(0)}
                            </div>
                        </div>
                    )}
                </a>
            </div>

            {/* Column 2: Name */}
            <div className="row-col row-name">
                <a href={link} target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}>{title}</a>
            </div>

            {/* Column 3: Description */}
            <div className="row-col row-desc">
                {description}
            </div>

            {/* Column 4: Website */}
            <div className="row-col row-website">
                <a href={link} target="_blank" rel="noopener noreferrer" className="website-link">
                    Website ↗
                </a>
            </div>
        </div>
    );
};

export default PortfolioRow;
